import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling past hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-163">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-ivory/95 backdrop-blur-md border-t border-gold/20 p-4 pb-safe" data-id="element-164">
          <a href="https://form.typeform.com/to/BGQF1C1p" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-saffron text-navy font-medium py-4 rounded-sm tracking-widest uppercase text-sm shadow-lg active:scale-[0.98] transition-transform" data-id="element-165">
            {t('stickyMobileCta.text')}
          </a>
        </motion.div>}
    </AnimatePresence>;
}